import { useEffect, useState } from "react";

const SavingsContainer = ({
  title = "Daily",
  savings = 3,
  description = "equivalent to driving 8 miles in a standard car",
  unit = "Kg",
}) => {
  const [animatedSavings, setAnimatedSavings] = useState(0);

  useEffect(() => {
    let start = animatedSavings; // Start from the current animatedSavings value
    const duration = 1000;
    const frameRate = 16;
    const increment = Math.abs(savings - start) / (duration / frameRate); // Calculate increment per frame

    const interval = setInterval(() => {
      if (start < savings) {
        start = Math.min(start + increment, savings);
      } else if (start > savings) {
        start = Math.max(start - increment, savings);
      }
      setAnimatedSavings(start); // Update animated savings

      if (start === savings) {
        clearInterval(interval);
      }
    }, frameRate);

    return () => clearInterval(interval); // Cleanup interval
  }, [savings]);

  return (
    <div className="flex flex-col w-full h-fit border border-black rounded-2xl p-8">
      <p className="font-bold xl:text-xl md:text-lg">{title}</p>
      <div className="flex flex-1 flex-col justify-end place-items-end gap-4 pt-8">
        <p className="font-bold xl:text-5xl md:text-4xl lg:text-7xl ">
          {animatedSavings.toFixed(2).toLocaleString()}
          {unit}
        </p>
        <div className="w-full border-[0.5px] border-black" />
        <p className="xl:text-sm md:text-xs font-normal">{description}</p>
      </div>
    </div>
  );
};

export default SavingsContainer;
